<style >
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.activeClass{
  background: #fff!important;
}
</style>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { authComputed } from "@/state/helpers";

export default {
  page: {
        
    title: "Offline Müşteri Listesi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "OFFLİNE MÜŞTERİ LİSTESİ",
      items: [
        {
          text: "ANASAYFA",
          href: "/",
        },
        {
          text: "OFFLİNE MÜŞTERİ LİSTESİ",
          active: true,
        },
      ],
      detailSearch:false,
      copy_index:null,
      list:{
        groups:[],
        dealers:[],
        tariffs:[],
      },
      filter:[],
      form:{},
      isLoading: false,
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: [
          {
            field: '',
            type: '',
          },
        ],
        page: 1,
        perPage: 50,
      },
      currentPage: 0,
      selected: 0,
      pageLength: 0,
        url: "members/offline",
        paginationOptions: {
        enabled: true,
        dropdownAllowAll: false,
        perPage: 50,
        setCurrentPage: 1,
        perPageDropdown: [50, 100, 200],
        nextLabel: 'Sonraki',
        prevLabel: 'Önceki',
        rowsPerPageLabel: 'Kayıt Göster',
        ofLabel: 'of',
        pageLabel: 'sayfa', // for 'pages' mode
        infoFn: params => `${params.firstRecordOnPage} - ${params.lastRecordOnPage} ( Toplam: ${params.totalRecords}) `,
      },
      selectOptions: {
        enabled: true,
        selectOnCheckboxOnly: true,
        selectionInfoClass: 'custom-class',
        selectionText: 'adet kayıt seçildi',
        clearSelectionText: 'seçimi iptal et',
        disableSelectInfo: false,
        selectAllByGroup: false,
      },
      columns: [
        {
          label: 'Kullanıcı Adı',
          field: 'username',
          sortable: false,
        },
        {
          label: 'Bayi',
          field: 'user_name',
          sortable: false,
        },
         {
          label: 'Oturum Baş. Tar.',
          field: 'acctstarttime',
        },
        {
          label: 'Oturum Süresi',
          field: 'acctsessiontime',
        },
         {
          label: 'İndirme',
          field: 'acctinputoctets',
        },
         {
          label: 'Yükleme',
          field: 'acctoutputoctets',
        },
        {
          label: 'Mikrotik İp',
          field: 'nasipaddress',      
          sortable: false,
        },
        {
          label: 'İp ',
          field: 'framedipaddress',
          sortable: false,
        }, 
        {
          label: 'M:A:C',
          field: 'callingstationid',
          sortable: false,
        },
        {	
          field: '#',
          sortable: false,
          thClass: 'width-50',
        },
      ],
    };
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    
    this.loadItems()
    this.$http.get('/group/search')
    .then(resp => {
        this.list.groups = resp.data.content
    })
    .catch(error => error)
    this.$http.get('/dealers/search')
    .then(resp => {
        this.list.dealers = resp.data.content
    })
    .catch(error => error)
  },
  methods: {
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => {
        this.totalRecords = response.totalRecords
        this.pageLength = response.pageLength
        this.currentPage = response.currentPage
        this.rows = response.rows
      })
    },
    getFromServer() {
      return new Promise((resolve, reject) => {
        this.$http.post(this.url, this.serverParams)
          .then(res => {
            resolve({
              rows: res.data.data,
              totalRecords: res.data.total,
              pageLength: res.data.last_page,
              currentPage: res.data.current_page,
            })
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fieldFn(rowObj) {
      return rowObj.nameozet
    },
    onSearch(params) {
       this.updateParams(params)
        this.loadItems()
    },
    goDetail(props) {
      this.$router.push({ name:'ozet', params:{ uuid: props.customer_id ,id: props.id }});
    },
    selectionChanged(a) {
      this.selected = a.selectedRows.length
    },
    formSubmit(){
      this.updateParams({columnFilters : {...this.form}});
      this.loadItems()
    },
    tariff(a){
        this.$http.post('/tariff/getByGroup', { groupName : a.target.value})
        .then(resp => {
            this.list.tariffs = resp.data.content.tariff
        })
        .catch(error => error)
    },
    async copyURL(copy, index) {
      this.copy_index = index
      await navigator.clipboard.writeText(copy);
    },
    allClear(){
        this.form = {}
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
             <vue-good-table
                mode="remote"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                @on-search="onSearch"
                :search-options="{
                  enabled: true,
                  placeholder: 'Kullanıcı adı, isim, soyisim alanlarında en az 3 harf ile arama yapınız'
                }"
                :select-options="selectOptions"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading"
                @on-selected-rows-change="selectionChanged"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
                <div slot="selected-row-actions">
                  <button class="btn btn-danger btn-sm" style="margin-right:10px">Mikrotikten At</button>
                  <button class="btn btn-warning btn-sm">Sms Gönder</button>
                </div>
              
                <template
                  slot="table-row"
                  slot-scope="props"
                >
                  <span
                    v-if="props.column.field === 'tariff_name'"
                    class="text-nowrap"
                  >
                    <b>{{ props.row.tariff_type }}</b> <br/>
                    {{ props.row.tariff_name }}
                  </span>
                   <span
                    v-else-if="props.column.field === 'username'"
                  >
                    <a href="javascript::void(0);"  @click.prevent="copyURL(props.row.username, props.index)" class="text-primary">
                        {{ props.row.username  }} <br>
                    </a>
                    <i v-if="props.index == copy_index" class="badge rounded-pill bg-success">Kopyalandı</i>
                  </span>
                  <span
                    v-else-if="props.column.field === '#'"
                    class="text-nowrap"
                  >
                    <ul class="list-inline font-size-20 contact-links mb-0">
                      <li class="list-inline-item">
                          <a title="Detay" @click="goDetail(props.row)">
                          <i class="bx bx-search-alt-2"></i>
                        </a>
                      </li>
                    </ul>
                  </span>
                  <span
                    v-else-if="props.column.field === 'status'"
                    class="text-nowrap"
                  >
                    <span v-if="props.row.status_id == 0" class="badge rounded-pill bg-primary">Potansiyel Üye</span>
                    <span v-if="props.row.status_id == 1" class="badge rounded-pill bg-success">Aktif</span>
                    <span v-if="props.row.status_id == 2" class="badge rounded-pill bg-secondary">Süreden Pasif</span>
                    <span v-if="props.row.status_id == 3" class="badge rounded-pill bg-danger">İptal Abone</span>
                    <span v-if="props.row.status_id == 4" class="badge rounded-pill bg-warning">Dondurulmuş Abone</span>
                  </span>
                </template>
             </vue-good-table>
        </div>
      </div>
    </div>
  </Layout>
</template>